const STORAGE_KEY = 'eds_dev_test_login_session';

export const isDevTestLoginEnabled = () => {
  return process.env.VUE_APP_ENABLE_TEST_LOGIN === 'true';
};

export const saveDevTestLoginSession = (payload) => {
  if (!isDevTestLoginEnabled()) {
    return;
  }
  const expiresIn = Number(payload.expires_in || 0);
  const session = {
    openid: payload.openid,
    token: payload.token,
    userinfo_id: payload.userinfo_id,
    expires_at: Date.now() + Math.max(60, expiresIn) * 1000
  };
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearDevTestLoginSession = () => {
  if (!isDevTestLoginEnabled()) {
    return;
  }
  window.sessionStorage.removeItem(STORAGE_KEY);
};

export const restoreDevTestLoginSession = (store) => {
  if (!isDevTestLoginEnabled()) {
    return false;
  }
  let session;
  try {
    session = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
  } catch (err) {
    clearDevTestLoginSession();
    return false;
  }
  if (!session || !session.openid || !session.token || Number(session.expires_at) <= Date.now()) {
    clearDevTestLoginSession();
    return false;
  }
  store.commit('setReqParams', {
    openid: session.openid,
    token: session.token
  });
  if (session.userinfo_id) {
    store.commit('setSelectedUserinfoId', session.userinfo_id);
  }
  return true;
};
